<template>
  <SelectContianer
    v-on:closeSelectContainer="close"
    :showChildSelect="showChildSelect"
  >
    <template slot="select-header">
      <div class="select-header-inner">
        <span>{{ curPayType.name }}</span>
        <span
          v-if="showDeleteIco"
          @click="save"
          class="edit-btn j-save-card-btn"
          href="javascript:;"
          >{{ letter.save }}</span
        >
        <span
          v-else
          @click="edit"
          class="edit-btn j-edit-card-btn"
          href="javascript:;"
          >{{ letter.edit }}</span
        >
      </div>
    </template>
    <template slot="select-content">
      <ul class="card-select-container j-card-select-container">
        <li
          class="select-items-popup"
          :class="{ active: card.KEY_VALUE == curCard.KEY_VALUE }"
          pointClass="j-select-card"
          @click="selectCard(card)"
          v-for="card in cardInfos"
          :key="card.KEY_VALUE"
        >
          {{ card.KEY_VALUE_DESC }}
          <em
            class="delete-ico j-delete-card-btn"
            v-if="showDeleteIco"
            @click.stop="deleteCard(card.KEY_VALUE)"
          ></em>
        </li>
        <li
          class="select-items-popup"
          pointClass="j-select-new-card"
          :class="{ active: !curCard.KEY_VALUE }"
          @click="useNewCard"
        >
          {{ letter.quickcard_use_new_card }}
          <em class="new-ico j-new-card-btn"></em>
        </li>
      </ul>
    </template>
  </SelectContianer>
</template>
<script>
import selectContainer from '@mixins/officialWebStore/selectContainer';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV2';
export default {
  name: 'QuickPayCardSelecter',
  mixins: [selectContainer],
  data() {
    return {
      showDeleteIco: false,
      confirmDelete: false
    };
  },
  props: ['curPayType', 'cardInfos', 'curCard'],
  methods: {
    selectCard(card) {
      clickButton({
        btnName: 'select_creditcard',
        locationKey: locationType.paytypeSection
      });
      this.$emit('selectCard', card);
    },
    edit() {
      this.showDeleteIco = true;
    },
    save() {
      this.showDeleteIco = false;
    },
    deleteCard(keyValue) {
      clickButton({
        btnName: 'delete_creditcard',
        locationKey: locationType.paytypeSection
      });
      this.$emit('deleteCard', keyValue);
    },
    useNewCard() {
      clickButton({
        btnName: 'add_new_creditcard',
        locationKey: locationType.paytypeSection
      });
      this.$emit('selectCard', {});
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/_dimen.scss';
.select-header-inner {
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
.edit-btn {
  text-align: center;
  font-size: 24px;
  color: #333;
  padding: 5px 30px;
  border-radius: 40px;
  @include g-border();
}
.select-items-popup {
  display: flex;
  justify-content: space-between;
  font-size: 26px;
  .delete-ico {
    float: right;
    display: inline-block;
    width: 29px;
    height: 29px;
    background-image: url($tmslgImg + 'delete.png');
  }
  .new-ico {
    float: right;
    display: inline-block;
    width: 28px;
    height: 28px;
    background-image: url($tmslgImg + 'new.png');
  }
}
</style>
